import React from "react";

import FeedbackHeader from "../../layout/FeedbackHeader";
import FeedbackRating from "../Input/FeedbackRating";

import { FeedbackFormLayout } from "../../layout/FeedbackFormLayout";
import Button from "../../../../components/Button";
import styles from "./Question13FlashCoachExperience.module.scss";

export const Question13FlashCoachExperience = ({
  supportRating,
  updateRatingFormData,
  submitFormData,
}) => {
  return (
    <>
      <FeedbackFormLayout
        title={"Experience with FLASH Coach"}
        subtitle={
          "Tell us about your experience using the platform and what you’d improve."
        }
      >
        <FeedbackHeader
          title={
            "How would you rate our support service (digital@tdcx.com) based on factors such as the speed of resolution, response time and communication skills?"
          }
        />
        <FeedbackRating
          inputID={"supportRating"}
          rating={supportRating}
          updateRatingFormData={updateRatingFormData}
        />
        <div className={styles.containerWrapper}>
          <div className={styles.container}>
            <Button
              color="primary"
              variant="contained"
              fullWidth
              onClick={submitFormData}
            >
              Send Feedback
            </Button>
          </div>
        </div>
      </FeedbackFormLayout>
    </>
  );
};
